/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type RequestChangePasswordWithoutLoggedInMutationVariables = Exact<{
  email: string;
}>;


export type RequestChangePasswordWithoutLoggedInMutation = { requestChangePasswordWithoutLoggedIn: { success: boolean, message: string | null } };


export const RequestChangePasswordWithoutLoggedInDocument = gql`
    mutation requestChangePasswordWithoutLoggedIn($email: String!) {
  requestChangePasswordWithoutLoggedIn(email: $email) {
    success
    message
  }
}
    `;

/**
 * __useRequestChangePasswordWithoutLoggedInMutation__
 *
 * To run a mutation, you first call `useRequestChangePasswordWithoutLoggedInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangePasswordWithoutLoggedInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestChangePasswordWithoutLoggedInMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useRequestChangePasswordWithoutLoggedInMutation(options: VueApolloComposable.UseMutationOptions<RequestChangePasswordWithoutLoggedInMutation, RequestChangePasswordWithoutLoggedInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestChangePasswordWithoutLoggedInMutation, RequestChangePasswordWithoutLoggedInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestChangePasswordWithoutLoggedInMutation, RequestChangePasswordWithoutLoggedInMutationVariables>(RequestChangePasswordWithoutLoggedInDocument, options);
}
export type RequestChangePasswordWithoutLoggedInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestChangePasswordWithoutLoggedInMutation, RequestChangePasswordWithoutLoggedInMutationVariables>;